import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import clsx from 'clsx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, hint, className, ...rest },
  ref,
) {
  return (
    <div className="w-full">
      <input
        ref={ref}
        className={clsx('input', invalid && 'input-error', className)}
        aria-invalid={invalid || undefined}
        {...rest}
      />
      {hint ? <p className={clsx('mt-1 text-xs', invalid ? 'text-err' : 'text-dim')}>{hint}</p> : null}
    </div>
  );
});

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={clsx('input min-h-[88px] resize-y', invalid && 'input-error', className)}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
});

export default Input;
